module.exports = __webpack_public_path__ + "img/shape-1.2ee64b0c.svg";